import { makeAutoObservable } from "mobx";

export enum ImpersonationType {
  Group = "group",
  Brand = "brand",
  Branch = "branch",
  User = "user",
}

export interface ImpersonationState {
  type: ImpersonationType | null;
  name: string | null;
}

export class ImpersonationStore {
  impersonation: ImpersonationState = {
    type: null,
    name: null,
  };

  constructor() {
    makeAutoObservable(this);
  }

  logAs(type: ImpersonationType, name: string) {
    this.impersonation = { type, name };
  }

  clear() {
    this.impersonation = { type: null, name: null };
  }

  get isImpersonating() {
    return !!this.impersonation.type;
  }

  get label() {
    if (!this.impersonation.type || !this.impersonation.name) return "";
    return `You are logged in as Restaurant (${this.impersonation.type})`;
  }
}
